import React from "react";
import OtherServicesCard from "./OtherServicesCard";
import { calculators } from "../utility/constains";

const ListOfOtherSer = () => {
  return (
    <div className="container mx-auto py-8">
      <h5 className="text-center mb-6 font-bold text-2xl font-heading tracking-wider">
        YOU MAY ALSO LIKE
      </h5>
      <div className="flex flex-wrap justify-center ml-4 mr-4 ">
        {calculators.map((calculator) => (
          <OtherServicesCard
            key={calculator.title}
            title={calculator.title}
            image={calculator.image}
          />
        ))}
      </div>
    </div>
  );
};

export default ListOfOtherSer;
